export const adminPl = {
    title: "Panel Administratora",
    usersList: "Lista użytkowników",
    createUser: "Utwórz nowego użytkownika",
    userName: "Nazwa użytkownika",
    userEmail: "Email",
    userPassword: "Hasło",
    userRole: "Rola",
    roleUser: "Użytkownik",
    roleAdmin: "Administrator",
    userLanguage: "Język",
    studiesCount: "Liczba badań",
    activeStudy: "Aktywne badanie",
    activeStudyBadge: "aktywne",
    noActiveStudy: "Brak",
    actions: "Akcje",
    delete: "Usuń",
    cancel: "Anuluj",
    create: "Utwórz",
    loading: "Ładowanie...",
    noUsers: "Brak użytkowników",
    noUsersMessage: "Nie znaleziono żadnych użytkowników w systemie.",
    deleteConfirm: "Czy na pewno chcesz usunąć tego użytkownika?",
    userCreated: "Użytkownik został utworzony",
    userDeleted: "Użytkownik został usunięty",
    errorFetching: "Błąd pobierania listy użytkowników",
    errorCreating: "Błąd tworzenia użytkownika",
    errorDeleting: "Błąd usuwania użytkownika",
    viewStudies: "Zobacz badania",
    userStudies: "Badania użytkownika",
    loadingStudies: "Pobieranie badań...",
    noStudies: "Brak badań",
    noStudiesMessage: "Ten użytkownik nie ma jeszcze żadnych badań.",
    study: "Badanie",
    studyName: "Nazwa badania",
    unnamedStudy: "Bez nazwy",
    marks: "Kategorie porównań",
    mark: "Kategoria",
    options: "Opcje",
    results: "Wyniki",
    comparisons: "porównań",
    status: "Status",
    completed: "Ukończone",
    incomplete: "Nieukończone",
    close: "Zamknij",
    errorFetchingStudies: "Błąd pobierania badań użytkownika",
    usersView: "Użytkownicy",
    studiesView: "Badania",
    translationsView: "Tłumaczenia",
    studiesList: "Lista badań",
    createStudy: "Utwórz nowe badanie",
    editStudy: "Edytuj badanie",
    studyUsers: "Użytkownicy",
    breakTime: "Czas przerwy",
    breakMinutes: "Minuty przerwy",
    breakSeconds: "Sekundy przerwy",
    breakAfterMark: "Dodaj przerwę po tej kategorii",
    markTitle: "Nagłówek kategorii",
    markTitlePlaceholder: "Np. Korzyści siedliskowe",
    pageGroup: "Strona kategorii",
    addOption: "Dodaj opcję",
    optionLabel: "Opcja",
    pageLabel: "Strona",
    pageTypeStart: "Startowa",
    pageTypeCategories: "Kategorie",
    pageTypeBreak: "Przerwa",
    pageTypeEnd: "Końcowa",
    addBreakPage: "Dodaj stronę przerwy",
    addCategoriesPage: "Dodaj stronę kategorii",
    deletePage: "Usuń stronę",
    movePageLeft: "Przesuń w lewo",
    movePageRight: "Przesuń w prawo",
    setAsActiveStudy: "Ustaw jako aktywne badanie użytkownika",
    activeStudyUpdated: "Aktywne badanie zostało zaktualizowane",
    errorUpdatingActiveStudy: "Błąd aktualizacji aktywnego badania",
    pageText: "Treść strony",
    pageTextPlaceholder: "Wpisz treść strony",
    defaultPageTextHint: "Pole jest puste — użytkownik zobaczy poniższą treść domyślną:",
    categoriesPageTitle: "Nagłówek strony kategorii",
    categoriesPageTitlePlaceholder: "Np. Część 1",
    downloadStudyJson: "Pobierz JSON",
    importStudyJson: "Importuj z JSON",
    invalidStudyJson: "Nieprawidłowy plik JSON badania",
    introText: "Tekst strony startowej",
    introTextPlaceholder: "Treść wstępu do badania",
    breakText: "Tekst strony przerwy",
    breakTextPlaceholder: "Treść komunikatu podczas przerwy",
    endText: "Tekst strony końcowej",
    endTextPlaceholder: "Treść przed wysłaniem badania",
    marksCount: "Liczba kategorii",
    edit: "Edytuj",
    noUsersAssigned: "Brak przypisanych użytkowników",
    studyCreated: "Badanie zostało utworzone",
    studyUpdated: "Badanie zostało zaktualizowane",
    studyDeleted: "Badanie zostało usunięte",
    errorCreatingStudy: "Błąd tworzenia badania",
    errorUpdatingStudy: "Błąd aktualizacji badania",
    errorDeletingStudy: "Błąd usuwania badania",
    deleteStudyConfirm: "Czy na pewno chcesz usunąć to badanie?",
    studyNamePlaceholder: "Wprowadź nazwę badania",
    selectUsers: "Wybierz użytkowników",
    optionsPlaceholder: "Opcje oddzielone znakiem | (np: Opcja 1 | Opcja 2 | Opcja 3)",
    optionsHint: "Wprowadź opcje oddzielone znakiem | (możesz używać przecinków w opcjach)",
    addMark: "Dodaj kategorię",
    noMarks: "Brak kategorii. Dodaj kategorię, aby utworzyć badanie.",
    update: "Zaktualizuj",
    translationsSectionTitle: "Tłumaczenia",
    userViewTranslationsTitle: "Tłumaczenia widoku użytkownika",
    adminPanelTranslationsTitle: "Tłumaczenia panelu administratora",
    downloadTranslations: "Pobierz JSON",
    uploadTranslations: "Wgraj JSON",
    translationLanguage: "Język",
    uploadNewTranslationVersion: "Wgraj nową wersję",
    noUploadedTranslations: "Brak wgranych tłumaczeń",
    noUploadedTranslationsMessage: "Dodaj język albo wgraj plik JSON, aby pojawił się na liście.",
    invalidTranslationsFile: "Nieprawidłowy plik JSON z tłumaczeniami",
    translationValidationTitle: "Nieprawidłowa struktura tłumaczenia",
    translationValidationHint: "Plik musi zawierać te same klucze co wzorcowe tłumaczenie dla wybranej sekcji.",
    translationMissingKeys: "Brakujące klucze",
    translationExtraKeys: "Nieznane klucze",
    translationsUploaded: "Plik tłumaczeń został wgrany",
    translationVersionUploaded: "Nowa wersja tłumaczenia została wgrana",
    errorFetchingTranslations: "Błąd pobierania tłumaczeń",
    errorUploadingTranslations: "Błąd wgrywania tłumaczeń",
    addCustomLanguage: "Dodaj własny język",
    translationLanguageName: "Nazwa języka",
    uploadLanguageFile: "Plik tłumaczenia (JSON)",
    translationFileReady: "Plik JSON gotowy do dodania",
    customLanguageCreated: "Nowy język został dodany",
    errorCreatingCustomLanguage: "Błąd dodawania nowego języka",
    deleteCustomLanguage: "Usuń język",
    deleteCustomLanguageConfirm: "Czy na pewno chcesz usunąć ten język? Tego nie można cofnąć.",
    customLanguageDeleted: "Język został usunięty",
    errorDeletingCustomLanguage: "Błąd usuwania języka",
    cannotDeleteBuiltInLanguage: "Wbudowanego języka nie można usunąć",
    userLanguageUpdated: "Język użytkownika został zaktualizowany",
    errorUpdatingUserLanguage: "Błąd aktualizacji języka użytkownika",
    responsesView: "Odpowiedzi",
    responsesList: "Lista odpowiedzi",
    noResponses: "Brak odpowiedzi",
    noResponsesMessage: "Nie znaleziono żadnych wysłanych odpowiedzi.",
    submissionHistory: "Historia wypełnień",
    submittedAt: "Data wysłania",
    updatedAt: "Data aktualizacji",
    viewResponses: "Zobacz odpowiedzi",
    viewSubmission: "Podgląd odpowiedzi",
    ranking: "Ranking",
    consistencyRatio: "Wskaźnik spójności (CR)",
    comparisonMatrix: "Macierz porównań",
    loadingResponses: "Pobieranie odpowiedzi...",
    errorFetchingResponses: "Błąd pobierania odpowiedzi",
    lastSubmission: "Ostatnie wypełnienie",
    submissionsCount: "Liczba wypełnień",
    submissionDetails: "Szczegóły odpowiedzi",
    exportSubmissionCsv: "Eksportuj CSV",
    weight: "Waga",
    noSubmissionHistory: "Brak historii wypełnień",
    noSubmissionHistoryMessage: "Ten użytkownik nie wysłał jeszcze odpowiedzi w tym badaniu.",
    studyContentTab: "Treść badania",
    studyTranslationsTab: "Tłumaczenia",
    studyLanguages: "Języki",
    defaultLanguage: "Język źródłowy",
    selectTranslationLanguage: "Dodaj język",
    noStudyTranslations: "Brak dodatkowych tłumaczeń",
    noStudyTranslationsMessage: "Wybierz język, aby dodać tłumaczenie treści badania.",
    deleteStudyTranslation: "Usuń tłumaczenie"
}

export default adminPl
